export const ExperienceSwitcherText = {
  WELCOME_TO_SUPPLIER: 'welcome_to_supplier',
  CHOOSE_YOUR_EXPERIENCE: 'choose_your_experience',
  CONTINUE: 'continue',
};
